module.exports = __webpack_public_path__ + "img/no_notifications.ccd9b07a.svg";